import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService} from "@services";
import {FetchRaceByIdRequest, Race} from "@model";
import {LANDING_ROUTE} from "../app-routing.module";

export const LiveRaceResolver: ResolveFn<Observable<Race | null> |
  Promise<Race> | Race> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService),
   router: Router = inject(Router)): Observable<Race | null> |
    Promise<Race> | Race => {
    let raceId = route.queryParams["raceId"];
    let eventId = route.queryParams["eventId"];
    if (raceId) {
      return liveResultsService.fetchLiveRace(
        new FetchRaceByIdRequest(raceId), true)
        .pipe(
          take(1),
          mergeMap((res: Race | null) => {
            if (res) {
              if (eventId && res.eventId && +eventId !== res.eventId) {
                router.navigate([]);
                return EMPTY;
              }
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    }
  }
